module.exports = __webpack_public_path__ + "img/d8sj-btn.86b8d7e4.png";